import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AlertOctagon, X } from 'lucide-react';

/* Shows a fixed banner whenever the current browser session is impersonating
 * a vendor or a customer (set by the admin "Login as" buttons). */
const ImpersonationBanner = () => {
  const loc = useLocation();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const reread = () => {
      try {
        const raw = localStorage.getItem('tgmart_impersonating');
        setInfo(raw ? JSON.parse(raw) : null);
      } catch { setInfo(null); }
    };
    reread();
    window.addEventListener('storage', reread);
    return () => window.removeEventListener('storage', reread);
  }, [loc.pathname]);

  if (!info) return null;
  // Don't show on the admin pages themselves
  if (loc.pathname.startsWith('/admin')) return null;

  const exitImpersonation = () => {
    if (info.role === 'vendor') localStorage.removeItem('tgmart_vendor_token');
    if (info.role === 'customer') {
      localStorage.removeItem('tgmart_token');
      localStorage.removeItem('tgmart_user');
    }
    localStorage.removeItem('tgmart_impersonating');
    window.location.href = '/admin';
  };

  return (
    <div
      className="fixed top-0 inset-x-0 z-[120] bg-amber-500 text-white text-sm shadow"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
        <AlertOctagon className="w-4 h-4 shrink-0" />
        <div className="flex-1 min-w-0 truncate">
          Admin impersonation active — viewing as <b>{info.role}</b>: <b>{info.name}</b>
        </div>
        <button
          onClick={exitImpersonation}
          className="text-xs px-2 py-1 rounded bg-white/20 hover:bg-white/30 transition-colors flex items-center gap-1"
          data-testid="exit-impersonation-btn"
        >
          <X className="w-3.5 h-3.5" /> Exit
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
